<div class="profileHolder">
  <dialog-title [fontSize]="'16px'" [titleHeight]="'60px'" [title]="(changingPassword ? 'Change Password' : 'Edit Profile')" [backgroundColor]="'#41474F'"></dialog-title>
  <div class="message" *ngIf="message && !passwordError">{{message}}</div>
  <div *ngIf="!changingPassword" class="main_content">
    <div class="profile_content">
      <div class="profile">
        <div class="photo">
          <div class="photo-holder">
            <div class="photo-top">
              <logo-handler 
                #logoHandler
                [imageData]="{ typeId: user.uid, type: 'profiles', subtype: 'photo' }"
                (uploadStatusChanged)="statusChange($event)"
              ></logo-handler>
              <photo [data]="user" [size]="120"></photo>
              <div class="uploading" *ngIf="wait_for_reload">
                <mat-progress-spinner [diameter]="40" mode="indeterminate" color="primary"></mat-progress-spinner>
              </div>
            </div>
            <div class="photo-menu">
              <div class="upload-button">
                UPLOAD PHOTO
                <input title="" type="file" class="upload-button-input" (change)="logoHandler.onFileChange($event)">
              </div>
              <div style="flex:1;"></div>
              <icon *ngIf="!deletingPhoto && user.photoURL" icon="delete_18px" (click)="deleteProfileImage($event)"></icon>
            </div>
          </div>
        </div>
        <form #profileForm="ngForm">
          <mat-form-field class="general">
            <input matInput name="firstName" [(ngModel)]="user.firstName" placeholder="First name" maxlength="64" required />
          </mat-form-field>
          <mat-form-field class="general">
            <input matInput name="lastName" [(ngModel)]="user.lastName" placeholder="Last name" maxlength="64" required />
          </mat-form-field>
          <mat-form-field class="general">
            <input matInput name="title" [(ngModel)]="user.title" placeholder="Job title" maxlength="64" />
          </mat-form-field>
          <mat-form-field class="general">
            <input matInput name="company" [(ngModel)]="user.company" placeholder="Company" maxlength="64" />
          </mat-form-field>
          <mat-form-field class="general">
            <textarea matInput cdkTextareaAutosize name="aboutMe" [(ngModel)]="user.aboutMe" placeholder="About me" maxlength="2000"></textarea>
          </mat-form-field>
          <mat-form-field class="general">
            <input matInput name="phone" [(ngModel)]="user.phone" placeholder="Mobile number" maxlength="32" />
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>
  <change-password #changePasswordComponent [errorMessage]="(passwordError ? message : '')" *ngIf="changingPassword"></change-password>
  <div mat-dialog-actions class="profileActions">
    <button mat-button (click)="(changingPassword ? changingPassword = false : close.emit())">CANCEL</button>
    <div style="flex:1;"></div>
    <button mat-button (click)="changingPassword = true" *ngIf="!fromOAuth && !changingPassword">CHANGE PASSWORD</button>
    <button mat-button color="primary" *ngIf="!changingPassword" [disabled]="!user.firstName || !user.lastName || loading" (click)="presave(profileForm)">SAVE</button>
    <button *ngIf="changingPassword" mat-button color="primary" (click)="changePassword()" [disabled]="submittingPassword || !changePasswordComponent || !changePasswordComponent.password || !changePasswordComponent.current_password || changePasswordComponent.password !== changePasswordComponent.conf_password || changePasswordComponent.passwordForm.controls['password']?.errors?.minlength">SAVE</button>
  </div>
</div>
